import React, { useState, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { Container, Grid, useMediaQuery } from "@material-ui/core"
import {
  SimpleLoading,
  PromotionalFooterPure,
  InstructionsPure,
  SignatureRequestPanelPureQueriesValidations,
  HeaderHLPure,
  DataPickerHLPure,
  InputHLPure,
  TooltipHLPure,
  DropDownBtnHLPure,
  ButtonHLPure,
  CheckBoxHLPure,
  DialogSystemGLPure
} from "../../pures"
import { Traslates } from "../../pures"
import { AutoComplete } from "@progress/kendo-react-dropdowns"
import "./request-signature-detail.css"

const RequestSignatureDetailView = (props) => {
  const { t } = useTranslation();
  let edit = t("cellDetailSignatureRequest.seeDetail");
  let tooltipSeeDetail = t("cellDetailSignatureRequest.tooltipSeeDetail");
  let tooltipDelete = t("cellDetailSignatureRequest.tooltipCancelSignRequest");
  let tooltipStampingTime = t(
    "cellDetailSignatureRequest.tooltipServiceStampingTime"
  );
  let tooltipConservationMessage = t(
    "cellDetailSignatureRequest.tooltipServiceConservationMessage"
  );

  const isMobile = useMediaQuery("(max-width:560px)")
  const longmatches = useMediaQuery("(max-width:1200px)")

  const globalContainerStyles = {
    display: "inline-block",
    justifyContent: "flex-start",
    maxWidth: "100%",
    backgroundColor: "white",
    width: "auto",
    // padding: "20px",
  };
  if (longmatches) {
    globalContainerStyles.marginRight = 0;
  }

  const [users, setUsers] = useState([]);
  let email = props.signerEmail;
  // const [email, setEmail] = useState("");
  // const [emailValidator, setEmailValidator] = useState(false);

  useEffect(() => {
    let temp = [];
    if (props?.user) {
      if (props?.user?.userMetaData) {
        if (props?.user?.userMetaData?.userA3Cloud) {
          temp.push({
            ...props?.user?.userMetaData.userA3Cloud,
          });
        }
      }
    }
    if (props?.collaboratorListAllow) {
      temp = temp.concat(props.collaboratorListAllow);
    }
    if (props?.inviteListAllow) {
      temp = temp.concat(props.inviteListAllow);
    }
    setUsers(temp);
  }, [props.collaboratorListAllow, props.inviteListAllow, props.user]);

  return (
    <div className="standard-wrapper">
      {
        props.loading ? (
          <SimpleLoading />
        ) : (
          <Container
            spacing={4}
            sm={12}
            xs={12}
            lg={12}
            md={12}
            style={globalContainerStyles}
          >
            <div className="RequestSignatureDetailView-header">
              <HeaderHLPure title={props.title} />
            </div>
            <Container maxWidth={"md"} disableGutters>
              <Grid container spacing={3} className='alertDetails'>
                <Grid item xs={12} className="" >
                  <InstructionsPure
                    instructions={[props.description]}
                  />
                </Grid>

                <Grid
                  item
                  lg={6}
                  md={6}
                  es={12}
                  className="item-datePickerField"
                >
                  <Traslates>
                    <DataPickerHLPure
                      labelDataPicker={t("requestSignatureDetailView.tooltiptextDateFrom")}
                      valueDate={props.dateFrom}
                      handleChangeDate={(e) => props.onChange(e, "dateFrom")}
                      tooltipShow
                      informationIcon
                      positionTooltip={isMobile ? "top" : "right"}
                      titleTooltip={t("requestSignatureDetailView.tooltiptextDateFrom")}
                      descriptionTooltip={t("requestSignatureDetailView.tooltipDescriptionDateFrom")}
                    />
                  </Traslates>
                  {props.errorDateFrom === true ? (
                    <span className="hint-message-error">
                      {props.messageErrorDateFrom}
                    </span>
                  ) : null}
                </Grid>
                <Grid
                  item
                  lg={6}
                  md={6}
                  es={12}
                  className="item-datePickerField"
                >
                  <Traslates>
                    <DataPickerHLPure
                      labelDataPicker={t("requestSignatureDetailView.tooltiptextDateTo")}
                      valueDate={props.dateTo}
                      handleChangeDate={(e) => props.onChange(e, "dateTo")}
                      tooltipShow
                      informationIcon
                      positionTooltip={isMobile ? "top" : "right"}
                      titleTooltip={t("requestSignatureDetailView.tooltiptextDateTo")}
                      descriptionTooltip={t("requestSignatureDetailView.tooltipDescriptionDateTo")}
                    />
                  </Traslates>
                  {props.errorDateTo === true ? (
                    <span className="hint-message-error">
                      {props.messageErrorDateTo}
                    </span>
                  ) : null}
                </Grid>

                <Grid item xs={12} className="item-inputField">
                  <InputHLPure
                    labelInput={t("requestSignatureDetailView.SignatureName")}
                    typeInput={"text"}
                    valueInput={props.nameSign}
                    handleChangeInput={(e) => props.onChange(e, "nameSign")}
                    inputActive
                    tooltipShow
                    informationIcon
                    positionTooltip={isMobile ? "top" : "right"}
                    titleTooltip={t("requestSignatureDetailView.SignatureName")}
                    descriptionTooltip={t("requestSignatureDetailView.tooltipDescriptionRequestName")}
                  />
                </Grid>
                <Grid item xs={12} className="item-inputField" >
                  <div style={{ display: "flex", alignItems: "baseline", gap: "5px" }}>
                    <label className="inputHLPure-label">{t("requestSignatureDetailView.tooltipSigner")}</label>
                    <TooltipHLPure
                      positionTooltip={isMobile ? "top" : "right"}
                      titleTooltip={t("requestSignatureDetailView.tooltipSigner")}
                      descriptionTooltip={t("requestSignatureDetailView.tooltipDescriptionSigner")}
                      informationIcon
                    />
                  </div>

                  <AutoComplete
                    className="RequestSignatureDetailView-item-inputField-thirdInLine"
                    onChange={({ value }) => {
                      // setEmailValidator(true);
                      // setEmail(value);
                      props.onChangeAutoComplete(value);
                      setTimeout(() => { }, 1500);
                    }}
                    value={email}
                    data={
                      email
                        ? users
                          .filter((i) =>
                            i.email
                              .toLowerCase()
                              .includes(email.toLowerCase())
                          )
                          .map((i) => i.email)
                        : users.map((i) => i.email)
                    }
                    required={false}
                  />
                </Grid>
                <Grid item xs={12} className="item-inputField" >
                  <DropDownBtnHLPure
                    labelDropDown={t("requestSignatureDetailView.SignatureStatus")}
                    optionsDropDown={props.signRequestStatusData}
                    onDropDownChange={props.onChangeComboBox}
                    optionsValue={props.signRequestStatus}
                    valueItem={"status"}
                    nameOption={"status"}
                  />
                </Grid>

                <Grid item xs={12} className="RequestSignatureDetailView-checkBox-sign">
                  <p className="label-sign">
                    {t("requestSignatureDetailView.SignatureType")}
                  </p>

                  <div className="RequestSignatureDetailView-checkBox-container">
                    <CheckBoxHLPure
                      labelCheckBox={t("requestSignatureDetailView.checkboxAll")}
                      checkedState={props.all}
                      idCheckBox={"all"}
                      onChangeHandler={props.onAcceptAll}
                    />

                    <CheckBoxHLPure
                      labelCheckBox={t("requestSignatureDetailView.checkboxSignature1")}
                      checkedState={props.eSign}
                      onChangeHandler={props.onAcceptESignature}
                    />

                    <CheckBoxHLPure
                      labelCheckBox={t("requestSignatureDetailView.checkboxSignature2")}
                      checkedState={props.electronic}
                      onChangeHandler={props.onAcceptElectronicSignature}
                    />

                    <CheckBoxHLPure
                      labelCheckBox={t("requestSignatureDetailView.checkboxSignature3")}
                      checkedState={props.autograph}
                      onChangeHandler={props.onAcceptAutographSignature}
                    />
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  className="RequestSignatureDetailView-btns"
                >
                  <Link to="/queries-and-validations" className="RequestSignatureDetailView-back-btn">
                    <ButtonHLPure
                      nameBtn={t("button.return")}
                      onClickBtn={props.scrollWindow}
                    />
                  </Link>
                  <ButtonHLPure
                    nameBtn={t("requestSignatureDetailView.consult")}
                    primary
                    onClickBtn={(e) => props.onHandleSearch(e)}
                  />
                </Grid>
              </Grid>
            </Container>
            {props.onFilter ? (
              <div className="requestSignatureDetailView-grid-container">
                <SignatureRequestPanelPureQueriesValidations
                  {...props}
                  seeDetail={edit}
                  tooltipDetail={tooltipSeeDetail}
                  tooltipStampingTime={tooltipStampingTime}
                  tooltipConservationMessage={tooltipConservationMessage}
                  onFilterSignRequest={props.onFilterSignRequest}
                  dataStateChange={props.dataStateChange}
                  view={"request-signature-detail"}
                />
              </div>
            ) : null}
            <Grid item xs={12} lg={12} md={12} sm={12} es={12}>
              <PromotionalFooterPure />
            </Grid>
            <DialogSystemGLPure
              showLoadingRequesting={props.showLoadingRequesting}
              toggleLoadingRequesting={props.toggleLoadingRequesting}

              showCompletedRequesting={props.showCompletedRequesting}
              toggleCompletedRequesting={props.toggleCompletedRequesting}
              messageComplete={props.messageComplete}

              showErrorRequesting={props.showErrorRequesting}
              toggleErrorRequesting={props.toggleErrorRequesting}
              messageError={props.messageError}

              showWarningRequesting={props.showWarningRequesting}
              messageWarning={props.messageWarning}
            />
          </Container>
        )
        // <Container spacing={4} sm={12} xs={12} lg={12} md={12} style={globalContainerStyles}>
        //     <Container es={12} className='table-card-queriesValidations' >
        //         <TitleTemplatePure title={props.titleFilter} />
        //         {/* <DescriptionTemplatePure description={props.descriptionFilter} className='description-filter' /> */}
        //         <SignatureRequestPanelPure {...props} seeDetail={edit} tooltipDetail={tooltipSeeDetail} tooltipStampingTime={tooltipStampingTime} tooltipConservationMessage={tooltipConservationMessage} onFilterSignRequest={props.onFilterSignRequest} dataStateChange={props.dataStateChange} view={'request-signature-detail'} />
        //         <Grid item xs={12} lg={12} md={12} sm={12} es={12} className='btns-signature'>
        //             <button onClick={props.onReturn} className='btn-style-signature'>{t('button.return')}</button>
        //         </Grid>
        //         <Grid item xs={12} lg={12} md={12} sm={12} es={12} >
        //             <PromotionalFooterPure />
        //         </Grid>
        //     </Container>
        // </Container>
      }
    </div>
  );
};

export { RequestSignatureDetailView as default };
